import React from "react";
import At from "./at";
import Da from "./da";
import En from "./en";

export default ({ lang }) => {
  const arrayLang = {
    da: Da,
    at: At,
    en: En,
  };
  const WhichComp = arrayLang[lang];

  return <WhichComp lang={lang} />;
};
